module.exports = "/_next/static/images/workingcapital-73fc41522ba87ebc7159384794c035da.svg";